(function () {
  function formatBadge(qty, available, policy) {
    if (!available && policy !== 'continue') return 'Sold out';
    if (qty >= 20) return '20+ in stock';
    if (qty > 0) return qty + ' in stock';
    if (available) return 'In stock';
    return 'Sold out';
  }

  function shipText(available, policy) {
    if (!available && policy !== 'continue') return 'Sold out';
    if (available) return 'Hurry! Limited stock left';
    return 'Sold out';
  }

  function barPct(qty, available, policy) {
    if (!available && policy !== 'continue') return 0;
    if (qty >= 20) return 75;
    if (qty > 0) return Math.max(12, Math.min(75, Math.round((qty / 20) * 100)));
    if (available) return 50;
    return 0;
  }

  function viewerNumber(productId) {
    var n = (Number(productId) % 9) + 7;
    var tick = Math.floor(Date.now() / 12000);
    return 7 + ((n + tick) % 9);
  }

  function sync(root, qty, available, policy) {
    var badge = root.querySelector('[data-pfc-stock-badge]');
    var ship = root.querySelector('[data-pfc-ship]');
    var fire = root.querySelector('[data-pfc-fire]');
    var bar = root.querySelector('[data-pfc-stock-bar]');
    var viewers = root.querySelector('[data-pfc-viewers]');
    var countEl = root.querySelector('[data-pfc-viewers-count]');
    var soldOut = !available && policy !== 'continue';

    if (badge) badge.textContent = formatBadge(qty, available, policy);
    if (ship) ship.textContent = shipText(available, policy);
    if (fire) fire.hidden = soldOut;
    if (bar) bar.style.width = barPct(qty, available, policy) + '%';
    root.classList.toggle('is-sold-out', soldOut);

    var showViewers = available && qty > 0;
    if (viewers) {
      viewers.hidden = !showViewers;
      if (showViewers && countEl) {
        countEl.textContent = String(viewerNumber(root.dataset.productId));
      }
    }
  }

  function variantRow(root, variantId) {
    var script = root.querySelector('[data-pfc-stock-variants]');
    if (!script) return null;
    try {
      var rows = JSON.parse(script.textContent);
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].id === variantId) return rows[i];
      }
    } catch (err) {
      return null;
    }
    return null;
  }

  function initStock(root) {
    sync(
      root,
      parseInt(root.dataset.inventoryQuantity, 10) || 0,
      root.dataset.variantAvailable === 'true',
      root.dataset.inventoryPolicy
    );

    if (!window.MinimogEvents) return;
    window.MinimogEvents.subscribe(root.dataset.productId + '__VARIANT_CHANGE', function (variant) {
      if (!variant) {
        sync(root, 0, false, 'deny');
        return;
      }
      var row = variantRow(root, variant.id);
      if (row) {
        sync(root, parseInt(row.inventory_quantity, 10) || 0, row.available, row.inventory_policy);
      }
    });
  }

  document.querySelectorAll('.pfc-pdp-stock').forEach(initStock);
})();
